// Tendência diária do NS de quantidade no mês corrente, com M-1 sombreado (SDD §7.1).
// Sem largura mínima: o gráfico se adapta ao viewport (mobile-first, sem scroll horizontal).
import {
  ResponsiveContainer, ComposedChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import { SerieDia } from '../types';
import { fmtPct } from '../utils/format';

const C = { s1: '#2a78d6', s2: '#1baf7a', grid: '#e1e0d9', muted: '#898781' };

export default function TrendChart({ serie }: { serie: SerieDia[] }) {
  const dados = serie.map((d) => ({
    dia: d.dia,
    atual: d.atual !== null ? d.atual * 100 : null,
    anterior: d.anterior !== null ? d.anterior * 100 : null,
  }));
  const valores = dados.flatMap((d) => [d.atual, d.anterior]).filter((v): v is number => v !== null);
  const min = Math.floor(Math.min(...valores, 100) - 2);

  return (
    <ResponsiveContainer width="100%" height={240}>
      <ComposedChart data={dados} margin={{ top: 6, right: 8, bottom: 0, left: 0 }}>
        <CartesianGrid stroke={C.grid} vertical={false} />
        <XAxis
          dataKey="dia" tick={{ fontSize: 11, fill: C.muted }} tickLine={false} axisLine={{ stroke: C.grid }}
          interval="preserveStartEnd" minTickGap={18}
        />
        <YAxis
          domain={[min, 100]} tick={{ fontSize: 11, fill: C.muted }} tickLine={false} axisLine={false}
          width={38} tickFormatter={(v: number) => `${v}%`}
        />
        <Tooltip
          contentStyle={{ fontSize: 12, borderRadius: 8 }}
          labelFormatter={(v) => `Dia ${v}`}
          formatter={(v) => fmtPct(Number(v) / 100)}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Area
          name="Mês anterior" type="monotone" dataKey="anterior"
          stroke={C.s2} strokeWidth={1.5} strokeDasharray="4 3" fill={C.s2} fillOpacity={0.12} connectNulls
        />
        <Line name="Mês corrente" type="monotone" dataKey="atual" stroke={C.s1} strokeWidth={2.5} dot={false} connectNulls />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
